<template>
    <div>
    <UserEmptyContactsWindow />
    <UserEmptyPhoneWindow />
    <UserNotFilledWindow />

    <div class="left-menu-block-wrapper">
        <div class="left-menu-block-inner">

            <router-link class="button-new-mail-main" :to="{name: 'MailCreate'}">
            <span class="text">
                <span class="icon"><PlusIcon/></span>
                Новое письмо
            </span>
            </router-link>
            <ul class="left-menu user-menu">
                <ClientNavigationItems/>
            </ul>
        </div>
    </div>
    </div>
</template>


<script>

    import ClientNavigationItems from "./ClientNavigationItems";
    import PlusIcon from "./icons/PlusIcon";
    import UserEmptyContactsWindow from "./windows/UserEmptyContactsWindow.vue";
    import UserEmptyPhoneWindow from "./windows/UserEmptyPhoneWindow.vue";
    import UserNotFilledWindow from "./windows/UserNotFilledWindow.vue";

    export default {
        name: 'ClientNavigation',

        components: {PlusIcon, ClientNavigationItems, UserEmptyContactsWindow, UserEmptyPhoneWindow, UserNotFilledWindow}
    }
</script>